/* eslint-disable custom/no-hardcoded-colors */

export const colors = {
  //1 - App Background
  //2 - Subtle background
  //3 - UI element background
  //4 - Hovered UI element background
  //5 - Active / Selected UI element background
  //6 - Subtle borders and separators
  //7 - UI element border and focus rings
  //8 - Hovered UI element border
  //9 - Solid backgrounds
  //10 - hovered solid backgrounds
  //11 - Low-contrast text
  //12 - High-contrast text

  primeGradient: `linear-gradient(180deg, #212B9A 0%, #030A4F 100%)`,
  primeBlue: '#212B9A',

  gray1: '#FFFFFF',
  gray2: '#F8F9FD',
  gray3: '#F2F5FC',
  gray4: '#EDF2FA',
  gray5: '#E4EAF7',
  gray6: '#D8E0EE',
  gray7: '#CAD5E7',
  gray8: '#BCC7DC',
  gray9: '#7D8AA1',
  gray10: '#717F99',
  gray11: '#5D6A81',
  gray12: '#13161B',
  gray13: '#4A505C',
  gray14: '#CAD5E8',
  gray15: '#AFBCD3',

  grayAlpha1: '#5272AD00',
  grayAlpha2: '#1F51AD08',
  grayAlpha3: '#3367C711',
  grayAlpha4: '#3B6DC91A',
  grayAlpha5: '#2D67D221',
  grayAlpha6: '#1A4AA22B',
  grayAlpha7: '#2E559E40',
  grayAlpha8: '#40609C59',
  grayAlpha9: '#00153D80',
  grayAlpha10: '#12295499',
  grayAlpha11: '#3A4964D0',
  grayAlpha12: '#000000E8',

  blue1: '#FBFCFF',
  blue2: '#F5F8FF',
  blue3: '#EDF3FF',
  blue4: '#E1EBFF',
  blue5: '#CEDEFE',
  blue6: '#B7CDF8',
  blue7: '#96B6F2',
  blue8: '#5E96EF',
  blue9: '#0062FF',
  blue10: '#0054F1',
  blue11: '#1C4DC0',
  blue12: '#051E57',
  blue13: '#042B7F',
  blue14: '#1F5BFF',
  blue15: '#14215B',

  blueAlpha1: '#0554FF04',
  blueAlpha2: '#0554FF0A',
  blueAlpha3: '#0252FF12',
  blueAlpha4: '#0151FF1E',
  blueAlpha5: '#0154EF30',
  blueAlpha6: '#014DE648',
  blueAlpha7: '#004EDF69',
  blueAlpha8: '#0058E6A1',
  blueAlpha9: '#0062FFFA',
  blueAlpha10: '#0554E6FA',
  blueAlpha11: '#1B4AC0FA',
  blueAlpha12: '#051E57FA',

  yellow1: '#FDFDF9',
  yellow2: '#FFFAE8',
  yellow3: '#FFF7D1',
  yellow4: '#FFF2BB',
  yellow5: '#FFEBA3',
  yellow6: '#FFE086',
  yellow7: '#F7CB64',
  yellow8: '#EBA800',
  yellow9: '#FFCB00',
  yellow10: '#F7B900',
  yellow11: '#6F5325',
  yellow12: '#38260C',

  yellowAlpha1: '#AB9A0506',
  yellowAlpha2: '#FFC40217',
  yellowAlpha3: '#FFD1012E',
  yellowAlpha4: '#FFCD0144',
  yellowAlpha5: '#FFC5055B',
  yellowAlpha6: '#FFBB0073',
  yellowAlpha7: '#F0A40093',
  yellowAlpha8: '#F0A400FA',
  yellowAlpha9: '#FFC800F5',
  yellowAlpha10: '#FAB700FA',
  yellowAlpha11: '#6E5025FA',
  yellowAlpha12: '#291800F0',

  green1: '#F6FEF7',
  green2: '#EDFDEF',
  green3: '#EDFDEF',
  green4: '#D7F6DB',
  green5: '#C4F0CB',
  green6: '#9BE6AB',
  green7: '#76DC8D',
  green8: '#3CCE6B',
  green9: '#0BAF3F',
  green10: '#089738',
  green11: '#1E5431',
  green12: '#06280F',

  greenAlpha1: '#0BF92B07',
  greenAlpha2: '#05C0150F',
  greenAlpha3: '#02B31117',
  greenAlpha4: '#01B60A23',
  greenAlpha5: '#01C1213B',
  greenAlpha6: '#01B1225C',
  greenAlpha7: '#00AD1A7A',
  greenAlpha8: '#00B224AD',
  greenAlpha9: '#009419C9',
  greenAlpha10: '#00801CD6',
  greenAlpha11: '#0E3F18E5',
  greenAlpha12: '#001A05F0',

  red1: '#FFF7F9',
  red2: '#FFF3F5',
  red3: '#FFEAEE',
  red4: '#FFE0E6',
  red5: '#FDD3DC',
  red6: '#F6B0BE',
  red7: '#EF99AB',
  red8: '#E67C92',
  red9: '#CC244B',
  red10: '#B52749',
  red11: '#8C2F45',
  red12: '#2D0C16',

  redAlpha1: '#85000207',
  redAlpha2: '#A8000E09',
  redAlpha3: '#D6002B13',
  redAlpha4: '#FF00331F',
  redAlpha5: '#F200302C',
  redAlpha6: '#D30D3250',
  redAlpha7: '#D50B346B',
  redAlpha8: '#C7002B81',
  redAlpha9: '#C2002AD6',
  redAlpha10: '#A30026D4',
  redAlpha11: '#7B0A26DB',
  redAlpha12: '#29000BF6',

  overlayBlackAlpha1: '#00000003',
  overlayBlackAlpha2: '#00000007',
  overlayBlackAlpha3: '#0000000C',
  overlayBlackAlpha4: '#00000012',
  overlayBlackAlpha5: '#00000017',
  overlayBlackAlpha6: '#0000001D',
  overlayBlackAlpha7: '#00000024',
  overlayBlackAlpha8: '#00000038',
  overlayBlackAlpha9: '#00000070',
  overlayBlackAlpha10: '#0000007A',
  overlayBlackAlpha11: '#00000090',
  overlayBlackAlpha12: '#000000E8',
  black: '#000000',

  overlayWhiteAlpha1: '#00000000',
  overlayWhiteAlpha2: '#FFFFFF03',
  overlayWhiteAlpha3: '#FFFFFF09',
  overlayWhiteAlpha4: '#FFFFFF0E',
  overlayWhiteAlpha5: '#FFFFFF16',
  overlayWhiteAlpha6: '#FFFFFF20',
  overlayWhiteAlpha7: '#FFFFFF2D',
  overlayWhiteAlpha8: '#FFFFFF3F',
  overlayWhiteAlpha9: '#FFFFFF62',
  overlayWhiteAlpha10: '#FFFFFF72',
  overlayWhiteAlpha11: '#FFFFFF97',
  overlayWhiteAlpha12: '#FFFFFFEB',

  orange1: '#FCDDC7',
  orange2: '#BB570F',
  orange3: '#FF5959',

  violet1: '#EECEFE',
  violet2: '#C496F2',

  white: '#FFFFFF',
  mustard: '#C39E42',

  neutral9: '#374266',

  purple2: '#FAF5FF',
  purple3: '#F6EDFF',
  purple5: '#E6CEFE',
  purple9: '#8E1CFF',
  purple10: '#650FBA',
  purple11: '#4B2991',
  purple12: '#2E0557',
};
